import { ChangeEvent } from 'react';
import { useIntl } from 'react-intl';
import {
    REPLAYS_PRE_REGISTRATION_ENABLED,
    REPLAYS_SESSION_LABEL,
    UPCOMING_SESSIONS_ENABLED,
    UPCOMING_SESSIONS_LABEL,
    UPCOMING_SESSIONS_TYPE,
} from '../../../../../../../../../../modules/passport-pages/config';
import { DefaultPageViewModel } from '../../../default-page.viewmodel';

export const useUpcomingSessions = (pageVm: DefaultPageViewModel) => {
    const { formatMessage } = useIntl();
    const { value: upcomingSessionsEnabled } = pageVm.getFieldByKey(UPCOMING_SESSIONS_ENABLED);
    const { value: replaysPreRegistrationEnabled } = pageVm.getFieldByKey(REPLAYS_PRE_REGISTRATION_ENABLED);

    const upcomingSessionsType = pageVm.getFieldByKey(UPCOMING_SESSIONS_TYPE);

    const upcomingSessionsLabelField = pageVm.getFieldByKey(UPCOMING_SESSIONS_LABEL);
    const upcomingSessionsLabel = formatMessage(pageVm.getFieldConfigByKey(UPCOMING_SESSIONS_LABEL).labelDescriptor);

    const replaysSessionLabelField = pageVm.getFieldByKey(REPLAYS_SESSION_LABEL);
    const replaysSessionLabel = formatMessage(pageVm.getFieldConfigByKey(REPLAYS_SESSION_LABEL).labelDescriptor);

    const handleToggleUpcomingSessions = () => {
        pageVm.setFieldValueByKey(UPCOMING_SESSIONS_ENABLED, !upcomingSessionsEnabled);
        [UPCOMING_SESSIONS_LABEL, REPLAYS_SESSION_LABEL, REPLAYS_PRE_REGISTRATION_ENABLED]
            .forEach(key => pageVm.setFieldDefaultValueByKey(key));
    };

    const handleUpcomingSessionsTypeChange = (e: ChangeEvent<HTMLSelectElement>) =>
        pageVm.setFieldValueByKey(UPCOMING_SESSIONS_TYPE, e.target.value);

    const handleUpcomingSessionsLabelChange = (e: ChangeEvent<HTMLInputElement>) =>
        pageVm.setFieldValueByKey(UPCOMING_SESSIONS_LABEL, e.target.value);

    const handleUpcomingSessionsLabelBlur = () =>
        pageVm.setValueTouched(UPCOMING_SESSIONS_LABEL);

    const handleReplaysSessionLabelChange = (e: ChangeEvent<HTMLInputElement>) =>
        pageVm.setFieldValueByKey(REPLAYS_SESSION_LABEL, e.target.value);

    const handleReplaysSessionLabelBlur = () =>
        pageVm.setValueTouched(REPLAYS_SESSION_LABEL);

    const handleTogglePreRegistration = () =>
        pageVm.setFieldValueByKey(REPLAYS_PRE_REGISTRATION_ENABLED, !replaysPreRegistrationEnabled);

    return {
        upcomingSessionsEnabled: upcomingSessionsEnabled as boolean,
        upcomingSessionsType: upcomingSessionsType,
        upcomingSessionsLabelField: upcomingSessionsLabelField,
        upcomingSessionsLabel: upcomingSessionsLabel,
        replaysSessionLabelField: replaysSessionLabelField,
        replaysSessionLabel: replaysSessionLabel,
        replaysPreRegistrationEnabled: replaysPreRegistrationEnabled as boolean,
        handleToggleUpcomingSessions: handleToggleUpcomingSessions,
        handleUpcomingSessionsTypeChange: handleUpcomingSessionsTypeChange,
        handleUpcomingSessionsLabelChange: handleUpcomingSessionsLabelChange,
        handleUpcomingSessionsLabelBlur: handleUpcomingSessionsLabelBlur,
        handleReplaysSessionLabelChange: handleReplaysSessionLabelChange,
        handleReplaysSessionLabelBlur: handleReplaysSessionLabelBlur,
        handleTogglePreRegistration: handleTogglePreRegistration,
    };
};